import { Trans } from '@lingui/macro'
import SettingsIcon from '@mui/icons-material/Settings'
import {
  Checkbox,
  Dialog,
  DialogContent,
  FormControlLabel,
  IconButton,
  Tooltip
} from '@mui/material'
import { setTestingOptions } from 'app/redux/actions/TestingOptionsActions'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DialogTitleWithIconClose } from '../common-components/DialogTitleWithIconClose'

export const TestingOptionsButton = () => {
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const dispatch = useDispatch()
  const simulateInternal = useSelector((state) => state?.testingOptions?.simulateInternal)

  return (
    <>
      <Dialog
        open={dialogOpen}
        fullWidth
        maxWidth='xs'
      >
        <DialogTitleWithIconClose
          label={<Trans>TESTING_OPTIONS_DIALOG_TITLE</Trans>}
          handleClose={() => setDialogOpen(false)}
        />
        <DialogContent>
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(simulateInternal)}
                onChange={e => {
                  dispatch(setTestingOptions({ simulateInternal: e.target.checked }))
                }}
              />
                }
            label={<Trans>SIMULATE_INTERNAL_ENVIRONMENT_LABEL</Trans>}
          />
        </DialogContent>
      </Dialog>
      <Tooltip title={<Trans>TESTING_OPTIONS_ICON_TOOLTIP</Trans>}>
        <IconButton
          onClick={() => {
            setDialogOpen(true)
          }}
        >
          <SettingsIcon sx={{ fontSize: 24 }} />
        </IconButton>
      </Tooltip>

    </>
  )
}
